import { render } from "./funcgrouplist.vue?vue&type=template&id=0fccb4ea&ts=true"
import script from "./funcgrouplist.vue?vue&type=script&lang=ts"
export * from "./funcgrouplist.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__